/**
 * 接口文档
 *  http://api-doc-sl.inshopline.com/#/project/80/feature%2F20210907_v1.0.0/interface/6105a415d6c715c23828b3e7cf1c0a2c
 */
export default {
  /**查库存批次列表 */
  stockBatchList: '/api/stocks/batch-stock/list',
  /** 批量查询库存数量*/
  stockNums: '/api/stocks/list',
  /** 试算结果 */
  // todo: 补上接口
  trialList: '/api/stocks/list',
  /** 获取支持上传库存销售平台列表 */
  platformList: '/api/stock/sync/platform/list',
  /** 库存试算 */
  stockTrial: '/api/stock/sync/manual/tryCalculateV2',
  /** 提交库存同步任务 */
  submitSyncStockTask: '/api/stock/sync/manual/submit',
  /** 重试：库存同步 */
  retrySyncStockTask: '/api/stock/sync/manual/retry',
  /** 库存更改接口（单个） */
  stocksChange: '/api/stocks/change',
  /** 库存批量更新*/
  stocksBatchChange: '/api/tasks/stock-change',

  batchUpdateSafetyStock: '/api/safety-stock/batch-update',

  updateSafetyStock: '/api/safety-stock/update',
  totalSafetyStockEditable: '/api/safety-stock/total/editable',

  getSafetyStockSettings: '/api/settings/safety-stock/get',
  clearSafetyStockSettings: '/api/settings/safety-stock/clear',
  updateSinglesSafetyStock: '/api/settings/safety-stock/single/save',
  updateTotalSafetyStock: '/api/settings/safety-stock/total/save',
}
